import React, { useEffect, useMemo, useState } from 'react';
import { Container } from 'reactstrap';
import PndApi from '../../../../../utils/pnd/PndRestApi'
import UserListTableView from './components/UserListTableView';
import SnackbarContent from '@mui/material/SnackbarContent';
import LinearProgress from '@mui/material/LinearProgress';
import ModalAccountCreationForm from '../components/AccountCreationModal';
import EditIcon from '@mui/icons-material/Edit';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import ModalPasswordReset from '../components/PasswordRest/ModalMerchantPasswordReset';
import { showNotification, successNofication } from 'src/shared/components/Notification';
import { ACCOUNT_LOIGN_RETRY_COUNT, ERROR_MESSAGES } from 'src/utils/pnd/PndConstants';
import { Tooltip } from '@mui/material';
import ConfirmationDialog from 'src/shared/components/ConfirmationDialog';
import PndRestApi from '../../../../../utils/pnd/PndRestApi';
import Badge from "react-bootstrap/Badge";

const UserIndex = () => {
  useEffect(() => {
    getMerchantUsers();
  }, [])

  const [reactTableData, setReactTableData] = useState([]);
  const [temp, setTempData] = useState("");
  const [viewDetailPopup, setViewDetailPopup] = useState(false);
  const [isTitle, setTitle] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isPasswordDiv, setPasswordDiv] = useState(false);
  const [isNoRecordFound, setNoRecordFound] = useState(false);
  const [showUnlockConfirmation, setShowUnlockConfirmation] = useState(false);
  const [isUnlockUserId, setUnlockUserId] = useState(null);
  const [isRedirect, setRedirect] = useState(false);
  if (isRedirect) {
    window.location.reload();
  }
  const showDialogBox = async (event) => {
    if (event) {
      setShowUnlockConfirmation(true);
      setUnlockUserId(event?.merchantUserId);
    }
  }
  const getMerchantUsers = async () => {
    try {
      setLoading(true);
      const response = await PndApi.GetMerchantUsers();
      if (response.status === 200 && response.data.status === 200) {
        setReactTableData({ tableHeaderData: columns, tableRowsData: response.data.data });
      }
      else if (response?.data?.status && response?.data?.status === 204) {
        setNoRecordFound(true);
      } else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:${response.data.message}`,
        );
        return;
      }

    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    } finally {
      setLoading(false);
    }
  };
  const closeDialog = () => {
    // Close confirmation dialog without performing unassignment
    setShowUnlockConfirmation(false);
  };

  const unlockUser = async () => {
    try {
      const response = await PndRestApi.UnlockedMerchantUserAccount(isUnlockUserId);
      if (response.status === 200 && response.data.status === 200) {
        successNofication(
          "theme-light",
          "ltr",
          `Message: User's account unlocked successfully.`
        );
        setRedirect(true);
      } else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:${response.data.message}`,
        );
        return;
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    }
  };

  
  const columns = useMemo(
    () => [
      {
        Header: '#',
        accessor: (row, i) => i + 1, // Or just use Cell below for more control
        disableGlobalFilter: true,
        disableSortBy: true,
        width: 15,
        Cell: ({ row }) => row.index + 1, // <-- This sets the serial number based on row index
      },
      {
        Header: 'Action',
        accessor: 'edit',
        disableSortBy: true,
        Cell: ({ row }) => (
          <div className="icon-style" style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start"}} >
            {row.original.retryCount >= ACCOUNT_LOIGN_RETRY_COUNT && (
              <Tooltip title="Click here to unlock the locked user">
                <LockOpenIcon
                  style={{ cursor: "pointer", color: "red" }}
                  onClick={() => showDialogBox(row.original)}
                />
              </Tooltip>
            )
            }
            <Tooltip title="Click here to edit the user details">
              <EditIcon style={{ cursor: "pointer" }} onClick={() => edit(row.original)} />
            </Tooltip>
            <Tooltip title="Click here to reset  user password">
              <LockIcon style={{ cursor: "pointer" }} onClick={() => resetPassword(row.original)} />
            </Tooltip>
          </div>
        ),
      },
      {
        Header: 'Merchant Name',
        accessor: 'merchantName',
        disableGlobalFilter: false,
      },
      {
        Header: 'Full Name',
        accessor: 'fullName',
        disableSortBy: false,
      },


      {
        Header: 'User Name',
        accessor: 'userName',
        disableGlobalFilter: false,
      },

      {
        Header: 'Email',
        accessor: 'emailId',
        disableGlobalFilter: false,
      },
      {
        Header: 'Mobile Number',
        accessor: 'mobileNo',

      },

      {
        Header: "Status",
        accessor: "active",
        disableGlobalFilter: false,
  
        Cell: ({ row }) =>
          row.original.userStatusId == 1 ? (
            <h6><Badge bg="success">ACTIVE</Badge></h6>
          ) : <h6><Badge bg="danger">IN-ACTIVE</Badge></h6>
      },
      
    ],
    [],
  );

  const edit = async (event) => {
    if (event.merchantUserId) {
      setTempData(event);
      setViewDetailPopup(true);
      setTitle("Edit - Merchant Users Details")
    }
  }

  const resetPassword = (event) => {
    if (event) {
      setTempData(event);
      setPasswordDiv(true);
      setTitle("Merchant User Password Reset")
    }
  }




  return (
    <Container>
      {(reactTableData && reactTableData != null && reactTableData.tableRowsData != null) && <UserListTableView reactTableData={reactTableData} />}
      {loading && <LinearProgress color="primary" />} {/* Display progress bar while loading */}
      {isNoRecordFound && <UserListTableView isNoRecordFound={isNoRecordFound} />}
      {isNoRecordFound && <SnackbarContent message={'No Record Found'} />}


      {viewDetailPopup &&
        <ModalAccountCreationForm
          modalShow={viewDetailPopup}
          setModalShow={setViewDetailPopup}
          userData={temp}
          isTitle={isTitle}
        />}
      {
        isPasswordDiv && <ModalPasswordReset
          modalShow={isPasswordDiv}
          setModalShow={setPasswordDiv}
          userData={temp}
          isTitle={isTitle}
        />}

      {showUnlockConfirmation && (
        <ConfirmationDialog
          open={showUnlockConfirmation}
          onClose={closeDialog}
          onConfirm={() => unlockUser()} // Pass the temp data to assignOrder
          title="Confirmation"
          message="Are you sure, Do you want to proceed?"
        />
      )
      }
    </Container>
  );
};

export default UserIndex;